/* RumPumBumm help centre (2026-09-28): the approved prototype's behaviour (design/contact-v2.js)
   on the store's FAQ list, which sections/rpb-help.liquid renders into the page. Topics and search
   redraw the answers with the prototype's markup; the question form checks its fields beside
   them, then sends through Shopify's contact form. The FAQ page has no form: its write buttons
   open the contact page with the question (?message=), which fills it into the form there. */
(() => {
  'use strict';
  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-rpb-help-data]').textContent);
    const t = data.t;
    const topicList = root.querySelector('#topic-list');
    const answers = root.querySelector('#help-answers');
    const search = root.querySelector('#help-search');
    const ask = root.querySelector('#ask');
    const params = new URLSearchParams(location.search);
    const requested = (params.get('topic') || '').toLowerCase();
    const match = requested && data.topics.find((item) => item.id === requested || item.id.includes(requested));
    let topic = match ? match.id : (data.topics[0] || {}).id;
    const count = (id) => data.entries.filter((entry) => entry.topic === id).length;

    function renderTopics() {
      const searching = Boolean(search.value.trim());
      topicList.innerHTML = data.topics.map((item) => `<button type="button" class="topic" data-topic="${esc(item.id)}" aria-pressed="${!searching && item.id === topic}"><span>${esc(item.name)}</span><small aria-label="${count(item.id)} answers">${count(item.id)}</small></button>`).join('');
    }
    function renderAnswers() {
      const words = search.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
      const items = words.length
        ? data.entries.filter((entry) => words.every((word) => `${entry.q} ${entry.text}`.toLowerCase().includes(word)))
        : data.entries.filter((entry) => entry.topic === topic);
      answers.innerHTML = items.length
        ? items.map((entry, index) => `<details class="answer"${index ? '' : ' open'}><summary>${esc(entry.q)}<span aria-hidden="true">›</span></summary><div class="answer-body">${entry.html}<div class="answer-feedback"><span>${esc(t.feedbackQuestion)}</span><button type="button" class="chip" data-helpful>${esc(t.yes)}</button><button type="button" class="chip" data-write="${esc(entry.q)}">${esc(t.no)}</button></div></div></details>`).join('')
        : `<div class="help-empty"><h2>${esc(t.emptyHeading)}</h2><p>${esc(t.emptyText)}</p><button type="button" class="pill dark" data-write="${esc(search.value.trim())}">${esc(t.write)}</button></div>`;
    }
    const render = () => { renderTopics(); renderAnswers(); };

    function showAskFields(show) {
      ask.querySelector('.ask-fields').hidden = !show;
      ask.querySelector('.ask-submit').hidden = !show;
      root.querySelector('#ask-done').hidden = show;
    }
    function openAsk(message) {
      ask.hidden = false;
      showAskFields(true);
      if (message) ask.querySelector('#ask-message').value = message;
      ask.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      ask.querySelector('#ask-name').focus({ preventScroll: true });
    }
    // Errors sit beside their fields and clear as soon as the field is corrected.
    const CHECKS = {
      name: (field) => (field.value.trim() ? '' : t.nameError),
      email: (field) => (!field.value.trim() ? t.emailMissing : field.validity.typeMismatch ? t.emailError : ''),
      message: (field) => (field.value.trim() ? '' : t.messageError),
    };
    function checkField(name) {
      const field = root.querySelector(`#ask-${name}`);
      const error = CHECKS[name](field);
      field.setAttribute('aria-invalid', String(Boolean(error)));
      root.querySelector(`#ask-${name}-error`).textContent = error;
      return !error;
    }

    function write(message) {
      if (ask) return openAsk(message);
      const link = root.dataset.writeLink;
      if (link) location.href = link + (message ? (link.includes('?') ? '&' : '?') + 'message=' + encodeURIComponent(message) : '');
    }

    if (topicList) {
    topicList.addEventListener('click', (event) => {
      const button = event.target.closest('[data-topic]');
      if (!button) return;
      topic = button.dataset.topic;
      search.value = '';
      render();
    });
    search.addEventListener('input', render);
    root.querySelector('#help-search-form').addEventListener('submit', (event) => event.preventDefault());
    }
    root.addEventListener('click', (event) => {
      const helpful = event.target.closest('[data-helpful]');
      if (helpful) helpful.closest('.answer-feedback').innerHTML = `<span class="thanks">${esc(t.thanks)}</span>`;
      const writer = event.target.closest('[data-write]');
      if (writer) write(writer.dataset.write);
      if (event.target.closest('[data-ask-again]')) { ask.reset(); openAsk(''); }
    });
    if (match && topicList) render();
    if (!ask) return;
    ask.addEventListener('input', (event) => {
      const name = (event.target.id || '').replace('ask-', '');
      if (CHECKS[name] && event.target.getAttribute('aria-invalid') === 'true') checkField(name);
    });
    ask.addEventListener('submit', (event) => {
      const invalid = ['name', 'email', 'message'].filter((name) => !checkField(name));
      if (!invalid.length) return; // Shopify sends it and brings the page back with the thank-you
      event.preventDefault();
      root.querySelector(`#ask-${invalid[0]}`).focus();
    });
    if (!ask.hidden && !root.querySelector('#ask-done').hidden) root.querySelector('#ask-done').focus();
    if (params.get('message')) openAsk(params.get('message'));
  }

  const start = () => document.querySelectorAll('[data-rpb-help]').forEach(init);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
